import React, { useEffect, useMemo, useState } from 'react';
import { AppModal } from 'src/components/AppModal';
import { useTable } from 'src/hooks/table/useTable';
import { AppTable } from 'src/components/AppTable';
import { Stack } from '@mui/material';
import { locals } from 'src/constants';
import { useTranslations } from 'src/hooks';
// import * as popupStyles from 'src/containers/MainPageApartmentsV2/components/ComponentAdditionalInfo/styles';
import {
  mockRows,
  mockColumns, mockVisibilityModel,
} from 'src/components/CrosstableContent/components/AppartmentSidebarCross/components/ApartmentSidebarHistory/mockData';
import { GridColumnVisibilityModel } from '@mui/x-data-grid/hooks/features/columns/gridColumnsInterfaces';
import {
  HistoryChip,
} from 'src/components/CrosstableContent/components/AppartmentSidebarCross/components/ApartmentSidebarHistory/components/HistoryChip';
import { translations } from 'src/constants/translations';
import { SearchField } from 'src/components/SearchField';
import { IFilterAllData, ListOfKeysFilterAllData } from 'src/typings/filter';
import { hexToRGB } from 'src/components/Marketplace/helpers';
import { AppInputSearch } from 'src/components/AppInputSearch';
import { useComplex } from 'src/hooks/app/use-complex';
import {
  useStyles,
} from './styles';

interface Props {
  currentLang: string;
  placement: IFilterAllData;
  isOpen: boolean;
  onClose: () => void;
}
export const ApartmentSidebarHistory: React.FC<Props> = ({
  currentLang, placement, isOpen, onClose,
}) => {
  const { complex, getComplexTranslation } = useComplex();
  const statusColor = (placement?.[ListOfKeysFilterAllData.placementStatusCrossTableColor]?.toString()
    || placement?.[ListOfKeysFilterAllData.placementStatusColor]?.toString() || '');
  const backgroundColorWithOpacity = hexToRGB(statusColor, '.1');
  const { getTranslations } = useTranslations();
  // const modalStyles = popupStyles.useStyles();
  const [search, setSearch] = useState<string>('');
  // const [filteredRows, setFilteredRows] = useState<IFilterAllData[]>([]);
  const styles = useStyles({ backgroundColorWithOpacity, statusColor });
  const [visibilityModel, setVisibilityModel] = useState<GridColumnVisibilityModel | undefined>();
  const {
    apiRef,
    rows,
    columns,
    setRows,
    setColumns,
    applyApi,
  } = useTable();

  useEffect(() => {
    setRows(mockRows);
    setColumns(mockColumns as any);
    setVisibilityModel(mockVisibilityModel);
    applyApi();
  }, [mockRows, mockColumns, mockVisibilityModel]);

  // const floor = complex.pla
  const filteredData = useMemo(() => {
    return mockRows.filter((row) => {
      return Object.values(row).some((value) => value.toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1);
    });
  }, [search, mockRows]);
  // console.log('filteredData', filteredData);
  // useEffect(() => {
  //   const filteredData = rows.filter((row) => {
  //     return Object.values(row).some((value) => value.indexOf(search.toLowerCase()) !== -1);
  //   });
  //   console.log('filteredData', filteredData);
  //   setFilteredRows(filteredData);
  // }, [search, rows]);

  useEffect(() => {
    if (JSON.stringify(filteredData) !== JSON.stringify(rows)) {
      setRows(filteredData);
    }
  }, [filteredData, rows]);

  function noRowsOverlayFunc() {
    return (
      <>
        <Stack height="100%" alignItems="center" justifyContent="center">
          {getTranslations(locals.appTranslations.appNoDataToDisplay)}
        </Stack>
      </>
    );
  }

  return (
    <AppModal
      open={isOpen}
      onClose={onClose}
      toggleClose={onClose}
      contentHeader={(
        <div className={styles.headerWrapper}>
          <div className="change-log">status change log</div>
          <div className="unit-identity">
            <span className="unit-special">
              #
              {placement?.[ListOfKeysFilterAllData.placementNumeration]}
            </span>
            <span className="unit-special">/</span>
            <span className="unit-special">
              {placement?.[ListOfKeysFilterAllData.placementFloor]}
              {' '}
              {getComplexTranslation(ListOfKeysFilterAllData.placementFloor)}
            </span>
            <span className="unit-special">/</span>
            <span className="unit-special">
              {getComplexTranslation(ListOfKeysFilterAllData.placementSection)}
              {' '}
              {placement?.[ListOfKeysFilterAllData.placementSection]}
            </span>
            <span className="unit-special">/</span>
            <span className="unit-special">
              {getComplexTranslation(ListOfKeysFilterAllData.placementHouse)}
              {' '}
              {placement?.[ListOfKeysFilterAllData.placementHouse]}
            </span>
            <div className="unit-meta-chips">
              <HistoryChip>{complex?.title[currentLang]}</HistoryChip>
              <HistoryChip>{placement?.[ListOfKeysFilterAllData.placementPlanningType]}</HistoryChip>
              <HistoryChip color={statusColor}>{placement?.[ListOfKeysFilterAllData.placementStatusCrossTableName]}</HistoryChip>
            </div>
          </div>
        </div>
    )}
      listClassName={{
        wrapperContent: styles.wrapperContent,
        wrapperContentHeader: styles.wrapperContentHeader,
        // customCloseButton: modalStyles.modalCustomCloseButton,
      }}
    >
      <>
        {apiRef?.current && columns && rows && visibilityModel && (
          <>
            <div className={styles.search}>
              <AppInputSearch
                placeholder="Search by deal ID, status, stage, actor…"
                onValueChange={(value) => setSearch(value)}
              />
            </div>
            <div className={styles.table}>
              <AppTable
                slots={{
                  noRowsOverlay: noRowsOverlayFunc,
                }}
                autosizeOnMount
                autoHeight
                apiRef={apiRef}
                columnVisibilityModel={visibilityModel}
                // onColumnVisibilityModelChange={handleColumnVisibilityChange}
                disableColumnFilter
            // disableColumnMenu={!isCrossTable}
                columns={columns}
                rows={rows}
              />
            </div>
          </>
        )}
      </>
    </AppModal>
  );
};
